import { useOrgContextOrgId } from '@townsquare/org-context';

/**
 * Includes the business logic for determining if teams is enabled.
 *
 * @returns boolean
 */
export const useIsTeamsEnabled = (): boolean => {
	const orgId = useOrgContextOrgId();
	return Boolean(orgId);
};
